export default __webpack_public_path__ + "static/media/s-4.e29a3342.jpg";